import { arrayOf, string } from 'prop-types';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { Button } from 'reactstrap';

import ActiveView from '../../associations/Association/ActiveView';
import api from '../../REST/api';
import { flash, tapFlashError, tapFlashSuccess } from '../../utils/flash';

export default function OpsOnsiteHandover({ selectedItems, itemsType }) {
  const [newOpsOnsiteId, setNewOpsOnsiteId] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const isSaveBtnDisabled = !newOpsOnsiteId || isSaving;
  const history = useHistory();

  const onChange = e => {
    setNewOpsOnsiteId(e.target.value);
  };

  const onSubmit = async () => {
    setIsSaving(true);
    flash(`Saving the selected ${itemsType}...`, 'info');
    try {
      await api
        .campaignsHandover({
          data: {
            opsOnsiteId: newOpsOnsiteId,
            opportunityIds: selectedItems,
          },
        })
        .catch(tapFlashError());
      tapFlashSuccess(`All ${itemsType} saved successfully`)();
      setTimeout(() => {
        history.go();
      }, '1000');
      // eslint-disable-next-line no-empty
    } catch (e) {
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <>
      <div className="col-md-2">Ops Onsite</div>
      <div className="col-md-8">
        <ActiveView
          isMulti={false}
          onSelectBlur={() => {}}
          name="newOpsOnsite"
          value={newOpsOnsiteId}
          type="user"
          onChange={onChange}
        />
      </div>
      <div className="col-md-2">
        <Button
          className="save"
          onClick={onSubmit}
          disabled={isSaveBtnDisabled}
        >
          Save
        </Button>
      </div>
    </>
  );
}

OpsOnsiteHandover.propTypes = {
  selectedItems: arrayOf(string.isRequired).isRequired,
  itemsType: string.isRequired,
};
